(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.innerWidth >= 750) return;

    customElements.whenDefined('slideshow-component').then(function() {
      setTimeout(function() {
        document.querySelectorAll('.card-gallery slideshow-component').forEach(function(slideshow) {
          var productId = slideshow.closest('[data-product-id]')?.getAttribute('data-product-id');
          if (!productId) return;
          var mod = Number(productId) % 10;
          if (mod >= 5) {
            var scroller = slideshow.querySelector('slideshow-slides');
            if (scroller) {
              scroller.scrollLeft = scroller.offsetWidth;
            }
          }
        });
      }, 500);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
